import axios from '@/common/axios'

const URL = '/api/geogrids'

// Legacy response shape: `{ has_more, geogrids: [...] }`. Unwrap into a
// flat array so AppTable consumes it directly; the `Has-More` header is set
// by Rails (HasPagination concern), so AppTable still reads it correctly.
// TODO(post-Vue2): drop unwrapping once the API can return a bare array.
export const listGeogrids = async(params) => {
  const res = await axios.get(URL, { params })
  return { ...res, data: res.data.geogrids }
}

export const fetchGeogrid = (id, params = {}) =>
  axios.get(`${URL}/${id}`, { params })

export const fetchGeogridSet = (id, position) =>
  axios.get(`${URL}/${id}/geogrid_sets/${position}`)

export const createGeogrid = (payload) =>
  axios.post(URL, payload)

export const updateGeogrid = (id, payload) =>
  axios.put(`${URL}/${id}`, payload)

// Server-side this is a soft delete (Geogrid#soft_delete), not a real DELETE.
export const softDeleteGeogrid = (id) =>
  axios.delete(`${URL}/${id}`)

export const addTag = (id, tag) =>
  axios.post(`${URL}/${id}/add_tag`, { tag })

// Send tag as a query param — Rails DELETE body parsing is flaky when the
// content type isn't set, and `params[:tag]` reads from either location.
export const removeTag = (id, tag) =>
  axios.delete(`${URL}/${id}/remove_tag`, { params: { tag } })

export const fetchCompetitorsList = (id, params) =>
  axios.get(`${URL}/${id}/competitors_list`, { params })

export const exportCompetitorsCsv = (id) =>
  axios.put(`${URL}/${id}/competitors_csv_export`)

export const totalCount = (params) =>
  axios.get(`${URL}/total_count`, { params })

export const fetchPreviews = (ids) =>
  axios.get(`${URL}/previews`, { params: { ids: ids.join(',') } })

export const bulkCsvExport = (payload) =>
  axios.put('/api/geogrids_bulk_actions/csv_export', payload)

export const fetchFilters = () =>
  axios.get(`${URL}/filters`)

// Bootstrap enums for the whole geogrids section (live + scheduled). Only
// fetched on client-side navigation into geogrids; full page loads hydrate
// the same data through the styxie payload.
export const fetchPageMeta = () =>
  axios.get(`${URL}/page_meta`)
